import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

/** The discipline's Survey tab, as the legacy list linked it. */
export const getDisciplineSurveysUrl = (disciplineId: number): string =>
  resolveUrl(AppRoute.DisciplinesSurveys, { id: disciplineId }) ?? ''
